/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useContext, useEffect } from 'react';
import { Navbar, NavbarBrand, NavbarToggler, Collapse, Nav, NavItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';
import moment from 'moment';
import parse from 'html-react-parser';

// local imports
import Logo from '../../assets/UW_Horizontal_Logo_Full.png'

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

const ProviderNavbar = (props) => {

    // contexts
    const { theme, colors, fontFamily } = useContext(ThemeContext);
    const { user, setUser, setIsAuthenticated, maintenance, selectedTimeZone, setUserApprovalStatus } = useContext(AuthContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenMenuDropdown, setIsOpenMenuDropdown] = useState(false);
    const [isOpenProfileDropdown, setIsOpenProfileDropdown] = useState(false);
    const [notifications, setNotifications] = useState({
        AvailableTimings: [],
        ProviderProfile: [],
        ProviderSession: [],
        MyClient: [],
        MyPricing: [],
        ProviderPayment: [],
        System: []
    });
    const [roleSwitchModal, setRoleSwitchModal] = useState({ visible: false, selectedRole: {} });
    const [generalAlertModal, setGeneralAlertModal] = useState({ visible: false, detail: { id: "", title: "", description: "" } });
    const [policyNConditionStatusAlertModal, setPolicyNConditionStatusAlertModal] = useState({ visible: false, detail: { id: "", title: "", description: "" } });
    const [agreeBox, setAgreeBox] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [selectedUserRoleValue, setSelectedUserRoleValue] = useState({});

    // useEffects
    useEffect(() => {
        let tempUserRoles = [];
        if (user.roles.includes('client')) {
            tempUserRoles.push({ label: 'Client', value: 'client' })
            if (user.selectedRole === 'client') {
                setSelectedUserRoleValue({ label: 'Client', value: 'client' });
            }
        } else {
            tempUserRoles.push({ label: 'Client', value: 'addClient' })
        }
        if (user.roles.includes('provider')) {
            setUser({ ...user, selectedRole: 'provider' })
            tempUserRoles.push({ label: 'Counsellor', value: 'provider' })
            setSelectedUserRoleValue({ label: 'Counsellor', value: 'provider' });
        } else {
            tempUserRoles.push({ label: 'Counsellor', value: 'addProvider' })
        }
        // if (user.roles.includes('organisation_admin')) {
        //     tempUserRoles.push({ label: 'Organsation', value: 'organsation_admin' })
        //     if (user.selectedRole === 'organisation_admin') {
        //         setSelectedUserRoleValue({ label: 'Organsation', value: 'organisation_admin' });
        //     }
        // } else {
        //     tempUserRoles.push({ label: 'Organsation', value: 'addOrgansation' })
        // }
        setUserRoles(tempUserRoles);
        ProviderService.getApprovalStatus().then(data => {
            setUserApprovalStatus(data.isApproved);
        })
        ProviderService.getProviderProfileImageAndEmail()
            .then(data => {
                try {
                    setUser({ ...user, profileImage: data.profileImage });
                } catch (err) {
                    Alert.error("Some error occured, please try again later or report support team.", {
                        position: 'top-right',
                        effect: 'slide'
                    });
                    GeneralService.logError('at Provider ProviderNavbar useEffect', 'Error in try catch block', err.stack);
                }
            })
        getNotifications();
    }, []);

    // utility functions
    const toggleMenuDropdown = () => setIsOpenMenuDropdown(!isOpenMenuDropdown);
    const toggleProfileDropdown = () => setIsOpenProfileDropdown(!isOpenProfileDropdown);

    const getNotifications = () => {
        AuthService.getNotifications().then(data => {
            try {
                data.notifications.System = data.notifications.System.filter(item => !item.readStatus);
                data.notifications.ProviderProfile = data.notifications.ProviderProfile.filter(item => !item.readStatus);
                data.notifications.ProviderSession = data.notifications.ProviderSession.filter(item => !item.readStatus);
                data.notifications.ProviderChat = data.notifications.ProviderChat.filter(item => !item.readStatus);
                data.notifications.AvailableTimings = data.notifications.AvailableTimings.filter(item => !item.readStatus);
                data.notifications.MyPricing = data.notifications.MyPricing.filter(item => !item.readStatus);
                data.notifications.MyClient = data.notifications.MyClient.filter(item => !item.readStatus);
                data.notifications.ProviderPayment = data.notifications.ProviderPayment.filter(item => !item.readStatus);
                setNotifications(data.notifications);
                for (let i = (data.notifications.System.length - 1); i >= 0; i--) {
                    if (!data.notifications.System[i].readStatus && data.notifications.System[i].type === "PolicyNConditionStatusAlert") {
                        if ((!document.URL.includes("cookiepolicy") && data.notifications.System[i].title.includes("Cookie")) || (!document.URL.includes("termsconditions") && data.notifications.System[i].title.includes("Terms")) || (!document.URL.includes("privacypolicy") && data.notifications.System[i].title.includes("Privacy"))) {
                            setPolicyNConditionStatusAlertModal({ visible: true, detail: { id: data.notifications.System[i]._id, title: data.notifications.System[i].title, description: data.notifications.System[i].description } });
                            break;
                        }
                    } else if (!data.notifications.System[i].readStatus && data.notifications.System[i].type === "GeneralAlert") {
                        setGeneralAlertModal({ visible: true, detail: { id: data.notifications.System[i]._id, title: data.notifications.System[i].title, description: data.notifications.System[i].description } });
                        break;
                    }
                }
            } catch (err) {
                Alert.error("Some error occured, please try again later or report support team.", {
                    position: 'top-right',
                    effect: 'slide'
                });
                GeneralService.logError('at Provider ProviderNavbar getNotifications', 'Error in try catch block', err.stack);
            }
        })
    }

    // handle functions
    const handleChangeSelectedUserRole = (e) => {
        setRoleSwitchModal({ visible: false, selectedRole: {} });
        if (e.value === 'addClient') {
            props.history.push('/client/landingscreen');
        } else if (e.value === 'addProvider') {
            props.history.push('/counsellor/landingscreen');
        } else if (e.value === 'addOrgansation') {
            props.history.push('/organisation/landingscreen');
        } else {
            setSelectedUserRoleValue(e);
            setUser({ ...user, selectedRole: e.value })
            if (e.value === 'client') {
                props.history.push('/client/dashboard');
            } else if (e.value === 'provider') {
                props.history.push('/counsellor/sessions');
            } else if (e.value === 'organsation_admin') {
                props.history.push('/organisation/dashboard');
            }
        }
    }

    const handleLogout = () => {
        try {
            AuthService.logout().then(data => {
                if (data.success) {
                    setUser(data.user);
                    setIsAuthenticated(false);
                    // props.history.push('/');
                } else {

                }
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider ProviderNavbar handleLogout', 'Error in try catch block', err.stack);
        }
    }

    const handlePolicyNConditionStatusSubmit = () => {
        if (!agreeBox) return;
        setIsLoading(true);
        AuthService.markNotificationAsRead("System", policyNConditionStatusAlertModal.detail.id).then((data) => {
            // const id = policyNConditionStatusAlertModal.detail.id;
            // for (let i = (user.notifications.System.length - 1); i >= 0; i--) {
            //     if (user.notifications.System[i]._id === id) {
            //         let tempNotification = { ...user.notifications };
            //         tempNotification.System[i].readStatus = true;
            //         setUser({ ...user, notifications: tempNotification });
            //         break;
            //     }
            // }
            setPolicyNConditionStatusAlertModal({ visible: false, detail: { id: "", title: "", description: "" } });
            setIsLoading(false);
        })
    }

    const handleSystemNotificationSubmit = (id) => {
        AuthService.markNotificationAsRead("System", generalAlertModal.detail.id).then((data) => {
            setGeneralAlertModal({ visible: false, detail: { id: "", title: "", description: "" } })
        })
    }

    const handleAvailableTime = () => {
        try {
            props.history.push({
                pathname: "/counsellor/availabledaytime"
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }

    const handleReserveSession = () => {
        try {
            props.history.push({
                pathname: "/counsellor/reservesession"
            })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
        }
    }

    return (
        <div>
            {maintenance.status ? <div className="alert alert-primary marquee" style={{ margin: "0 -15px" }}><div>Umang Wellness is going to conduct maintenace to improve your experience. It will go under maintenance on {moment(maintenance.startAt).format("DD-MM-YYYY [at] hh:mm A")} for {maintenance.duration} minutes. During these time you won't be able to use Umang Wellness.</div></div> : null}
            <Navbar id="provider-navbar" color="white" light expand="md" style={{ fontFamily: fontFamily.primary }}>
                <NavbarBrand className="p-0" href="/">
                    <img id="brand-logo" style={{ maxWidth: "160px", height: "auto", border: "none", margin: "0" }} src={Logo} alt="Umang Logo" />
                </NavbarBrand>
                <Nav className="ml-auto" navbar>
                    <NavItem>
                        <Dropdown id="profile-menu" className="ml-auto" isOpen={isOpenProfileDropdown} toggle={toggleProfileDropdown}>
                            <DropdownToggle style={{ border: 0, background: 'transparent', padding: 0 }} id="profileDropdown">
                                <div className="text-center" style={{ width: "45px", height: "45px" }}>
                                    <img className="w-100 h-100" src={user.profileImage} alt="Profile picture" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                                </div>
                                {(notifications.ProviderProfile.length + notifications.ProviderSession.length + notifications.AvailableTimings.length + notifications.MyPricing.length + notifications.MyClient.length + notifications.ProviderPayment.length) > 0 ? <span className="notificationBadge">{notifications.ProviderProfile.length + notifications.ProviderSession.length + notifications.AvailableTimings.length + notifications.MyPricing.length + notifications.MyClient.length + notifications.ProviderPayment.length}</span> : null}
                            </DropdownToggle>
                            <DropdownMenu right>
                                <DropdownItem id="user-email" header>
                                    {user.email}
                                </DropdownItem>
                                <DropdownItem id="user-name" className="mt-0 pt-0" header>
                                    {user.username}
                                </DropdownItem>
                                <DropdownItem id="user-name" className="mt-0 pt-0" header>
                                    {`Last login: ${user.lastLoginAt ? user.lastLoginAt.old ? moment(user.lastLoginAt.old).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY HH:mm") : moment(user.lastLoginAt.new).utcOffset(selectedTimeZone.isDST ? selectedTimeZone.dst_offset : selectedTimeZone.offset).format("DD-MM-YYYY HH:mm") : ""}`}
                                </DropdownItem>
                                <Link id="profile-link" to="/counsellor/profile">
                                    <DropdownItem>Profile{notifications.ProviderProfile.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.ProviderProfile.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link id="sessions-link" to="/counsellor/sessions">
                                    <DropdownItem>Sessions{notifications.ProviderSession.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.ProviderSession.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link id="available-timings-link" to="/counsellor/availabledaytime">
                                    <DropdownItem>Available Timings{notifications.AvailableTimings.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.AvailableTimings.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link id="pricing-link" to="/counsellor/mypricing">
                                    <DropdownItem>My Pricing{notifications.MyPricing.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.MyPricing.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link id="client-list-link" to="/counsellor/clients">
                                    <DropdownItem>My Clients{notifications.MyClient.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.MyClient.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link to="/counsellor/reservesession">
                                    <DropdownItem id="reserve-session-link" onClick={handleReserveSession}>Reserve Session</DropdownItem>
                                </Link>
                                <Link id="payments-link" to="/counsellor/payments">
                                    <DropdownItem>My Payments{notifications.ProviderPayment.length > 0 ? <Badge className="ml-1" style={{ backgroundColor: colors.primary }}>{notifications.ProviderPayment.length}</Badge> : null}</DropdownItem>
                                </Link>
                                <Link to="/counsellor/subscription">
                                    <DropdownItem>My Subscription</DropdownItem>
                                </Link>
                                <Link to="/counsellor/clientsubscription">
                                    <DropdownItem>Client Subscription</DropdownItem>
                                </Link>
                                <Link to="/counsellor/settings">
                                    <DropdownItem>Settings</DropdownItem>
                                </Link>
                                <Link to="/contactus">
                                    <DropdownItem>Contact Us</DropdownItem>
                                </Link>
                                <DropdownItem id="guided-tour-link" onClick={props.showTutorial}>Guided Tour</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem id="roleSwitch" onClick={() => setRoleSwitchModal({ visible: true, selectedRole: selectedUserRoleValue })}>Switch Role</DropdownItem>
                                <DropdownItem id="logout" onClick={handleLogout}>Logout</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </NavItem>
                </Nav>
            </Navbar>
            <Modal size="sm" isOpen={generalAlertModal.visible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setGeneralAlertModal({ visible: false, detail: { title: "", description: "" } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>{generalAlertModal.detail.title}</span></ModalHeader>
                <ModalBody>{generalAlertModal.detail.description}</ModalBody>
                <ModalFooter><Button onClick={() => handleSystemNotificationSubmit()}>Ok</Button></ModalFooter>
            </Modal>
            <Modal size="sm" isOpen={roleSwitchModal.visible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setRoleSwitchModal({ visible: false, selectedRole: {} })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Select Role</span></ModalHeader>
                <ModalBody className="text-center" style={{ fontSize: "1.2rem", fontWeight: "600" }}>
                    <p style={{ fontSize: "1rem", fontWeight: "normal", marginBottom: "1.5rem" }}>By selecting role you'll be switch to that role, if you have not signed up for the role you'll be redirected to signup page.</p>
                    {userRoles.map((item, index) => (
                        <div key={index} className="p-2 my-3" style={selectedUserRoleValue.value === item.value ? theme.selectedSlotCard : theme.slotCard} onClick={() => handleChangeSelectedUserRole(item)}>{item.label}</div>
                    ))}
                </ModalBody>
            </Modal>
            <Modal size="lg" isOpen={policyNConditionStatusAlertModal.visible} backdrop={true}>
                <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setPolicyNConditionStatusAlertModal({ visible: false, detail: { title: "", description: "" } })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>{policyNConditionStatusAlertModal.detail.title}</span></ModalHeader>
                <ModalBody>
                    {parse(policyNConditionStatusAlertModal.detail.description)}
                    <div className="form-check mt-2">
                        <input className="form-check-input" type="checkbox" style={{ width: "1rem", height: "1rem" }} id="agree" checked={agreeBox} onChange={(e) => setAgreeBox(e.target.checked)} />
                        <label className="form-check-label ml-2" htmlFor="cb4">I have read and agree to updated Privacy Policy.</label>
                    </div>
                </ModalBody>
                <ModalFooter style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                    <Button type="button" style={theme.formSubmit} disabled={!agreeBox} onClick={() => handlePolicyNConditionStatusSubmit()}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default ProviderNavbar;